module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/star-filled-d61a562029483ee612fe07dfebbd1489.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/star-filled.svg
// module id = Xiuk
// module chunks = 24